import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Ruler, Loader2 } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";

const BASE = "/admin/podcast-finder";

export const ScreeningBar = ({ onProgress, maxRatings }) => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const wasPending = useRef(0);
  const poll = () => api.get(`${BASE}/screening`).then((r) => {
    setSt(r.data);
    if (r.data.pending !== wasPending.current) { wasPending.current = r.data.pending; onProgress?.(); }
  }).catch(() => {});
  useEffect(() => {
    poll();
    const t = setInterval(() => { if (wasPending.current > 0) poll(); }, 5000);
    return () => clearInterval(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const rescreen = async () => {
    if (!window.confirm("Check every Ready, Queued and No-email show against the size cap and network wording? Shows that fail move to Filtered with the reason. Already-emailed shows are left alone.")) return;
    setBusy(true);
    try { const { data } = await api.post(`${BASE}/prospects/rescreen`, { ids: [] }); toast.success(`Checking ${data.started} show${data.started === 1 ? "" : "s"} in the background`); wasPending.current = -1; await poll(); }
    catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  if (!st) return null;
  return (
    <div className={`mb-3 flex flex-wrap items-center gap-3 rounded-xl border px-3 py-2 text-xs ${st.pending > 0 ? "border-sky-400/30 bg-sky-400/10 text-sky-100" : "border-white/10 bg-white/5 text-slate-300"}`} data-testid="finder-screening-bar">
      {st.pending > 0 ? <Loader2 size={13} className="animate-spin text-sky-300" /> : <Ruler size={13} className="text-slate-400" />}
      <span data-testid="finder-screening-status">
        {st.pending > 0 ? <>Sizing up <b>{st.pending}</b> show{st.pending === 1 ? "" : "s"} — reading Apple and Spotify ratings. Shows over {maxRatings ?? 100} ratings or on another network move to Filtered.</> : st.unscreened > 0 ? <><b>{st.unscreened}</b> show{st.unscreened === 1 ? " hasn't" : "s haven't"} had a size check yet.</> : <>Every Ready / Queued show has passed the size check (≤ {maxRatings ?? 100} Apple or Spotify ratings, not on another network).</>}
      </span>
      {st.pending === 0 && <Button type="button" size="sm" variant="outline" onClick={rescreen} disabled={busy} className="ml-auto h-7 rounded-full border-white/15 bg-transparent text-xs hover:bg-white/10" data-testid="finder-rescreen">{busy ? <Loader2 size={12} className="mr-1.5 animate-spin" /> : <Ruler size={12} className="mr-1.5" />} {st.unscreened > 0 ? "Run size check" : "Re-check all"}</Button>}
    </div>
  );
};
